var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"margin-top":"100px"}},[_c('section',{staticClass:"header5 cid-u7ancmRRnP",attrs:{"data-bs-version":"5.2","id":"header05-1x"}},[_c('iframe',{attrs:{"width":"100%","src":"https://tamilsneham.smugmug.com/browse/","title":"description"}})])])
}]

export { render, staticRenderFns }